import { render, staticRenderFns } from "./DetailItem.vue?vue&type=template&id=f7696e84&scoped=true"
import script from "./DetailItem.vue?vue&type=script&lang=js"
export * from "./DetailItem.vue?vue&type=script&lang=js"
import style0 from "./DetailItem.vue?vue&type=style&index=0&id=f7696e84&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7696e84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7696e84')) {
      api.createRecord('f7696e84', component.options)
    } else {
      api.reload('f7696e84', component.options)
    }
    module.hot.accept("./DetailItem.vue?vue&type=template&id=f7696e84&scoped=true", function () {
      api.rerender('f7696e84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/dragItem/DetailItem.vue"
export default component.exports